import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from '../../services/alerts.service';
import { UserService } from '../../services/user.service';
import { ProductService } from '../../services/product.service';

/**
 * Component for rotating the angle of selected image-type products.
 */
@Component({
	selector: 'image-rotate',
	templateUrl: './image-rotate.component.html',
	styleUrl: './image-rotate.component.css'
})
export class ImageRotateComponent implements OnInit {
	@Input() productGroup: any;

	LOCALIZATION: any;

	angle: string = "";
	inprogress: boolean = false;

	constructor(
		private userService: UserService,
		private alertsService: AlertsService,
		private productService: ProductService,
		private ngbmodalService: NgbActiveModal
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
	}

	rotate(): void {
		if (!this.angle) {
			this.alertsService.error({
				message: "Rotation angle is not selected.",
				delay: 5000
			});
			return;
		}

		if (this.productGroup.ids) {
			this.inprogress = true;
			this.productService.rotateProductsImages(this.productGroup.ids, { angle: this.angle }).then(
				(response: any) => {
					this.alertsService.success({
						title: "Rotation Successful",
						message: "Document images have been rotated successfully."
					});
					this.close();
				},
				() => {
					this.inprogress = false;
					this.alertsService.error({
						message: "Failed to rotate some images. Only image formats are supported. In-place images are not supported.",
						delay: 5000
					});
				}
			);
		}
	};

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.ngbmodalService.dismiss();
	}
}
